import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { BrandCases } from "@/components/BrandCases";
import { About } from "@/components/About";
import { CareAndSustainability } from "@/components/CareAndSustainability";
import { ProductGallery } from "@/components/ProductGallery";
import { Benefits } from "@/components/Benefits";
import { ESGCommitment } from "@/components/ESGCommitment";
import { UseCases } from "@/components/UseCases";
import { Clients } from "@/components/Clients";
import { MediaSection } from "@/components/MediaSection";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import { PrivacyPolicy } from "@/components/PrivacyPolicy";
import { TermsOfService } from "@/components/TermsOfService";
import { ThankYou } from "@/components/ThankYou";
import { FormModalProvider } from "@/components/FormModalContext";

const Home = () => {
  // Tracking do Google Ads já está implementado nos botões diretamente
  // via trackAndOpenWhatsApp() - não precisa de init automático

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <BrandCases />
      <About />
      <CareAndSustainability />
      <ProductGallery />
      <Clients />
      <Benefits />
      <ESGCommitment />
      <MediaSection />
      <FAQ />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <FormModalProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/equipes" element={<Home />} />
            <Route path="/onboarding" element={<Home />} />
            <Route path="/promocionais" element={<Home />} />
            <Route path="/orcamento" element={<Home />} />
            <Route path="/sustentavel" element={<Home />} />
            <Route path="/eventos" element={<Home />} />
            <Route path="/politica-privacidade" element={<PrivacyPolicy />} />
            <Route path="/termos-uso" element={<TermsOfService />} />
            <Route path="/obrigado" element={<ThankYou />} />
          </Routes>
        </FormModalProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
